import { Locale } from 'antd/lib/locale-provider';
import { localeMap } from 'src/stores/SettingsStore/localeMap';

export const importSupportedLocales = async (
    supportedLocales: string[],
): Promise<SupportedLocalesMap> => {
    const supportedLocalesEntries = await Promise.all(
        supportedLocales
            .filter((locale) => locale !== 'en') // en locale is loaded by default
            .map((supportedLocale) => {
                const { antd, moment } = localeMap[supportedLocale] || {};

                return (async () => {
                    let antdLocale;
                    if (moment) {
                        try {
                            await importMoment(moment);
                        } catch (error) {
                            console.error(
                                `Date localization will not work!!!\n Couldn't import moment locale for ${supportedLocale}; error: ${error}`,
                            );
                        }
                    } else {
                        console.error(
                            `Date localization will not work!!!\n No moment locale for ${supportedLocale}, fix localeMap to match backend locale format`,
                        );
                    }

                    if (antd) {
                        try {
                            antdLocale = await importAntdLocale(antd);
                        } catch (error) {
                            console.error(
                                `Antd localization will not work!!!\n Couldn't import antd locale for ${supportedLocale}; error: ${error}`,
                            );
                        }
                    } else {
                        console.error(
                            `Antd localization will not work!!!\n No antd locale for ${supportedLocale}, try fixing localeMap`,
                        );
                    }

                    return [supportedLocale, antdLocale];
                })();
            }),
    );

    return Object.fromEntries(supportedLocalesEntries);
};

const importAntdLocale = async (locale: string): Promise<Locale> => {
    const { default: antdLocale } = await import(`antd/es/locale/${locale}.js`);

    return antdLocale;
};

const importMoment = (locale: string): Promise<void> => {
    return import(`moment/locale/${locale}`);
};

export type SupportedLocalesMap = Record<string, Locale | undefined>;
